module.exports = __webpack_public_path__ + "img/onboarding.395496c4.jpg";